import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import {
  translate,
  defaultTheme,
  ViewTitle,
  SimpleShowLayout,
  SimpleForm,
  SelectInput,
} from 'admin-on-rest'
import { Card, CardHeader } from 'material-ui/Card'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import { crudGetOne as crudGetOneAction } from 'admin-on-rest'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'

import Toggle from 'material-ui/Toggle'
import Checkbox from 'material-ui/Checkbox'
import TextField from 'material-ui/TextField'
import {
  Toolbar,
  ToolbarGroup,
  ToolbarSeparator,
  ToolbarTitle,
} from 'material-ui/Toolbar'

import * as moment from 'moment'

import { CourseView } from '../components/CourseView'
import ReactToPrint from '../components/ReactToPrint'
import InstructorStudentsAttendanceListToPrint from '../components/InstructorStudentsAttendanceListToPrint'
import InstructorStudentsCatalogToPrint from '../components/InstructorStudentsCatalogToPrint'
import InstructorCoursePageConfirmedList from './InstructorCoursePageConfirmedList'
import InstructorCoursePageNotConfirmedList from './InstructorCoursePageNotConfirmedList'
import InstructorCoursePageManageList from './InstructorCoursePageManageList'

import {
  getCourseFullDetails,
  updateAttendance,
  updatePaymentReceiptStatus,
  updateGrade,
  startCourse,
  endCourse,
} from '../reducers'
import { cancelCourse } from '../actions/coursesActions'
import { getStudentName, isStudentPresent } from '../helpers'

class InstructorsCoursePage extends React.Component {
  state = {
    isDialogOpen: false,
    showDialogInput: false,
    dialogInputText: '',
    dialogMessage: '',
    dialogTitle: '',
  }

  componentDidMount() {
    this.props.getCourseFullDetails(this.props.id)
    this.isAdmin = localStorage.getItem('role') === 'admin'
  }

  orderStudents = (students) =>
    students.sort((s1, s2) =>
      getStudentName(s1) === ''
        ? 1
        : getStudentName(s2) === ''
        ? -1
        : getStudentName(s1) < getStudentName(s2)
        ? -1
        : 1,
    )

  getStudents(isConfimed = null) {
    if (isConfimed === null) {
      return this.orderStudents(this.props.students)
    }
    if (this.props.course.cost > 0) {
      return this.orderStudents(
        this.props.students.filter((student) => {
          let hasPaid = false

          const payment =
            student.hasOwnProperty('payments') &&
            student.payments[this.props.id]
          if (payment) {
            const hasReceipt =
              payment.hasOwnProperty('receipt') && payment.receipt == true
            const hasCardReceipt =
              payment.hasOwnProperty('cardReceipt') &&
              payment.cardReceipt == true
            hasPaid = hasReceipt || hasCardReceipt
          }

          return isConfimed ? hasPaid : true
        }),
      )
    } else {
      // This is a free course
      return isConfimed ? this.orderStudents(this.props.students) : []
    }
  }

  handleCancelCourse = () => {
    return this.setState({
      dialogTitle: 'Atentie',
      dialogMessage: 'Aceasta actiune va anula cursul',
      showDialogInput: true,
      isDialogOpen: true,
      actions: [
        <FlatButton
          label="NU VREAU SA ANULEZ CURSUL"
          primary={true}
          onClick={this.handleDismiss}
        />,
        <FlatButton
          label="ANULEAZA CURS"
          secondary={true}
          onClick={() =>
            cancelCourse(
              this.props.id,
              this.props.course,
              this.props.students,
              this.state.dialogInputText,
            )
          }
        />,
      ],
    })
  }

  handleStartCourse = (willValidate = true) => {
    const course = this.props.course
    if (this.getStudents(true).length === 0) {
      return this.setState({
        dialogTitle: 'Atentie',
        dialogMessage:
          'Nu exista studenti cu taxa achitata. Cursul nu poate incepe',
        isDialogOpen: true,
        showDialogInput: false,
        actions: [
          <FlatButton
            label="OK"
            secondary={true}
            onClick={this.handleDismiss}
          />,
        ],
      })
    }
    if (willValidate) {
      if (this.getStudents(false).length > 0) {
        return this.setState({
          dialogTitle: 'Atentie',
          dialogMessage:
            'Nu toti studentii inscrisi au facut dovada platii. Studentii care nu au achitat taxa de participare nu vor putea fi notati la curs',
          isDialogOpen: true,
          showDialogInput: false,
          actions: [
            <FlatButton
              label="ANULEAZA"
              secondary={true}
              onClick={this.handleDismiss}
            />,
            <FlatButton
              label="CONTINUA ORICUM"
              primary={true}
              onClick={() => this.handleStartCourse(false)}
            />,
          ],
        })
      }
    }
    this.props.startCourse(this.props.id, course)
  }

  handleEndCourse = (willValidate = true) => {
    const course = this.props.course
    if (willValidate) {
      if (!course.hasOwnProperty('grades')) {
        course['grades'] = {}
      }

      let allStudentsPresent = true
      let studentsAbsent = {}

      this.getStudents(true).map((student) => {
        if (!isStudentPresent(course, student.id)) {
          allStudentsPresent = false
          studentsAbsent[getStudentName(student)] = true
        }
      })

      let studentsThatNeedGrades = {}
      this.getStudents(true).map((student) => {
        if (!course.grades.hasOwnProperty(student.id)) {
          if (!studentsAbsent.hasOwnProperty(getStudentName(student))) {
            // If this student was not absent, he needs a grade.. if he was absent, he doesn't need a grade
            studentsThatNeedGrades[getStudentName(student)] = true
          }
        }
      })
      let doStudentsNeedGrades = Object.keys(studentsThatNeedGrades).length > 0

      if (!allStudentsPresent || doStudentsNeedGrades) {
        let message = (
          <div>
            <div>
              {!allStudentsPresent && (
                <span>
                  Studentii listati au fost absenti in cel putin una din zile si
                  nu vor primi creditele aferente cursului
                </span>
              )}
              <ul>
                {Object.keys(studentsAbsent).map((studentName) => (
                  <li key={studentName}>{studentName}</li>
                ))}
              </ul>
            </div>
            {doStudentsNeedGrades && (
              <div>
                <span>
                  Va rugam adaugati note pentru urmatorii studenti pentru a
                  putea incheia cursul
                </span>
                <ul>
                  {Object.keys(studentsThatNeedGrades).map((studentName) => (
                    <li key={studentName}>{studentName}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )

        return this.setState({
          dialogTitle: 'Va rugam confirmati urmatoarele aspecte:',
          dialogMessage: message,
          isDialogOpen: true,
          showDialogInput: false,
          actions: doStudentsNeedGrades
            ? [
                <FlatButton
                  label="OK"
                  primary={true}
                  onClick={this.handleDismiss}
                />,
              ]
            : [
                <FlatButton
                  label="ANULEAZA"
                  secondary={true}
                  onClick={this.handleDismiss}
                />,
                <FlatButton
                  label="CONTINUA ORICUM"
                  primary={true}
                  onClick={() => this.handleEndCourse(false)}
                />,
              ],
        })
      }
    }

    this.props.endCourse(this.props.id, course)
  }

  handleDismiss = () => {
    this.setState({ isDialogOpen: false, showDialogInput: false })
  }

  render() {
    const { course, translate } = this.props

    return (
      <div>
        <Dialog
          title={this.state.dialogTitle}
          actions={this.state.actions}
          modal={false}
          open={this.state.isDialogOpen}
          onRequestClose={this.handleDismiss}
        >
          <div>
            <div>{this.state.dialogMessage}</div>

            {this.state.showDialogInput && (
              <div>
                <br />
                <br />
                <div>
                  Motiv anulare curs (se va trimite un email automat tuturor
                  participantilor):
                </div>
                <br />
                <textarea
                  type="text"
                  rows="10"
                  cols="50"
                  value={this.state.dialogInputText}
                  onChange={(e) =>
                    this.setState({ dialogInputText: e.target.value })
                  }
                />
              </div>
            )}
          </div>
        </Dialog>
        <Card>
          <ViewTitle title={`${course.name}`} />
          <CardHeader
            title={`Detalii curs:`}
            subtitle={translate(`courses.status.${this.props.course.status}`)}
          />
          <SimpleShowLayout record={course}>
            <CourseView />
          </SimpleShowLayout>
          {(this.props.course.status === 'upcoming' || this.isAdmin) && (
            <InstructorCoursePageConfirmedList
              courseId={this.props.id}
              course={this.props.course}
              students={this.getStudents(true)}
            />
          )}
          {(this.props.course.status === 'upcoming' || this.isAdmin) && (
            <InstructorCoursePageNotConfirmedList
              courseId={this.props.id}
              course={this.props.course}
              students={this.getStudents(false)}
            />
          )}
          {(this.props.course.status === 'in_progress' ||
            this.props.course.status === 'completed' ||
            this.isAdmin) && (
            <InstructorCoursePageManageList
              isAdmin={this.isAdmin}
              courseId={this.props.id}
              course={this.props.course}
              students={this.getStudents(true)}
            />
          )}
          <br />
          <Toolbar>
            <ToolbarGroup firstChild={true}>
              {this.props.course.status !== 'completed' && (
                <RaisedButton
                  label="Printeaza lista de prezenta"
                  onClick={() => this.printerAttendanceRef.handlePrint()}
                  primary={true}
                />
              )}
              <RaisedButton
                label="Printeaza catalog"
                onClick={() => this.printerCatalogRef.handlePrint()}
                primary={true}
              />
            </ToolbarGroup>
            {this.props.course.status === 'upcoming' && (
              <ToolbarGroup>
                <RaisedButton
                  label="Anuleaza curs"
                  secondary={true}
                  onClick={this.handleCancelCourse}
                />
                <RaisedButton
                  label="Incepe curs"
                  primary={true}
                  onClick={this.handleStartCourse}
                />
              </ToolbarGroup>
            )}
            {this.props.course.status === 'in_progress' && (
              <ToolbarGroup>
                <RaisedButton
                  label="Incheie curs"
                  secondary={true}
                  onClick={this.handleEndCourse}
                />
              </ToolbarGroup>
            )}
          </Toolbar>
        </Card>
        <div style={{ display: 'none' }}>
          <ReactToPrint
            trigger={() => <a href="#">Print this out!</a>}
            content={() => this.attendanceTableListRef}
            ref={(el) => (this.printerAttendanceRef = el)}
          />
          <InstructorStudentsAttendanceListToPrint
            course={this.props.course}
            students={this.getStudents()}
            ref={(el) => (this.attendanceTableListRef = el)}
          />
          <ReactToPrint
            trigger={() => <a href="#">Print this out!</a>}
            content={() => this.catalogToPrintRef}
            ref={(el) => (this.printerCatalogRef = el)}
          />
          <InstructorStudentsCatalogToPrint
            course={this.props.course}
            students={this.getStudents(true)
              .map((student) => ({
                ...student,
                grade: student.courses[this.props.id] ? student.courses[this.props.id].grade : '',
              })).sort((a, b) => {
                return isStudentPresent(this.props.course, a.id) ? -1 : 1
              })}
            ref={(el) => (this.catalogToPrintRef = el)}
          />
        </div>
      </div>
    )
  }
}

InstructorsCoursePage.defaultProps = {
  theme: defaultTheme,
  id: null,
  course: {},
  students: [],
}

function mapStateToProps(state, props) {
  const id = props.match.params.id
  const students = state.instructors.courses[id]
    ? state.instructors.courses[id].students
    : []

  const course = state.instructors.courses[id]
    ? state.instructors.courses[id].course
    : {}

  return {
    course,
    students,
    id,
    isLoading: state.admin.loading > 0,
  }
}

const enhance = compose(
  translate,
  connect(mapStateToProps, {
    crudGetOne: crudGetOneAction,
    getCourseFullDetails,
    updateAttendance,
    updatePaymentReceiptStatus,
    updateGrade,
    startCourse,
    endCourse,
  }),
)

export default enhance(InstructorsCoursePage)

const styles = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
}



// WEBPACK FOOTER //
// ./src/instructors/InstructorsCoursePage.js